<div id="ChartPerformanceReportComponent">
    <app-highcharts-render
        [chartStructure]="chartStructure()"
    ></app-highcharts-render>
</div>
